/* eslint-disable import/no-anonymous-default-export */
import axios from 'axios'
import { API_ENDPOINTS } from 'constants'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getTodayRates: () => {
    return axios.get(API_ENDPOINTS.GET_TODAY_RATES, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  },
  getBannerProcess: () => {
    return axios.get(API_ENDPOINTS.GET_BANNER, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  },
  getDeliveryProcess: () => {
    return axios.get(API_ENDPOINTS.GET_DELIVERY_PROCESS, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  },
  getShopbyCategory: () => {
    return axios.get(API_ENDPOINTS.GET_SHOP_BY_CATEGOTY, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  },
  getAbout: () => {
    return axios.get(API_ENDPOINTS.GET_ABOUT, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  },
  getTryon: () => {
    return axios.get(API_ENDPOINTS.GET_TRYON, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  },
  getLatestProducts: () => {
    return axios.get(API_ENDPOINTS.GET_LATEST_PRODUCTS, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  },
  getTestimonial: () => {
    return axios.get(API_ENDPOINTS.GET_TESTIMONIALS, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  },
  getContactDetails: () => {
    return axios.get(API_ENDPOINTS.GET_CONTACT_DETAIL, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  },
}
